import {BigNumber} from 'bignumber.js';
import {instanceOf, Number, String, transform} from 'effect/Schema';

export const BigNumberFromSelf = instanceOf(BigNumber);

export const BigNumberFromString = transform(String, BigNumberFromSelf, {
    strict: true,
    decode: fromA => BigNumber(fromA),
    encode: toI => toI.toString(),
});

export const BigNumberFromNumber = transform(Number, BigNumberFromSelf, {
    strict: true,
    decode: fromA => BigNumber(fromA),
    encode: toI => toI.toNumber(),
});
